import {
    getReportType,
    listReportTypes
} from './queries';

import {GraphQLQuery,} from '@aws-amplify/api';
import {ReportType} from "../types.ts";
import {generateClient} from "aws-amplify/api";


export type ListReportTypes = {
    listReportTypes: { items: ReportType[] }
}

export type GetReportType = {
    getReportType: ReportType
}

const client = generateClient();

export const fetchRecords = async () => {
    const response = await client.graphql<GraphQLQuery<ListReportTypes>>({
                                                                             query: listReportTypes,
                                                                         });
    return response.data?.listReportTypes;
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetReportType>>({
                                                                           query: getReportType,
                                                                           variables: {id: id},
                                                                       });
    return response.data?.getReportType;
};
